import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { Router } from '@angular/router';
import { SharedModule } from '../shared.module';

export type SignOffChoice = 'end_day' | 'temporary';

@Component({
  selector: 'app-sign-off-choice',
  standalone: true,
  imports: [CommonModule, SharedModule, MatDialogModule, MatRippleModule],
  templateUrl: './sign-off-choice.component.html',
  styleUrl: './sign-off-choice.component.scss',
})
export class SignOffChoiceComponent {
  private dialogRef = inject(MatDialogRef<SignOffChoiceComponent>);
  private router = inject(Router);

  onEndDay(): void {
    this.dialogRef.close('end_day');
  }

  onTemporary(): void {
    this.dialogRef.close('temporary');
  }
}